export const GET_PROFILE = 'pages/member/profile/getProfile'
